import { FormHelperText, TextField } from "@mui/material";
import { FormControl } from "./index";
import PropTypes from "prop-types";
import ReactPhoneInput from 'react-phone-input-material-ui';

const TextBox = props => {
    const {
        name,
        label,
        value,
        fullWidth,
        helperText,
        required
    } = props;
    
    return (
        <FormControl
            key={`key${name}`}
            error={helperText ? true : false}
            fullWidth={fullWidth}
        >
            
            <ReactPhoneInput
                value={value}
                defaultCountry={'us'}
                label={`${label} ${required ? '*' : ''} `}
                isValid={helperText ? false : true}
                onChange={(e) => props.onChange(e)} // passed function receives the phone value
                component={TextField}
            />


            {helperText &&
                <FormHelperText>
                    {helperText}
                </FormHelperText>}
        </FormControl>
    );
};

TextBox.propTypes = {
    name: PropTypes.string,
    label: PropTypes.string,
    error: PropTypes.string,
    value: PropTypes.string,
    required: PropTypes.bool,
    fullWidth: PropTypes.bool,
    helperText: PropTypes.string,
    disabled: PropTypes.bool,
    onChange: PropTypes.func,
}

TextBox.defaultProps = {
    variant: "outlined",
    error: "",
    value: "",
    required: false,
    fullWidth: false,
    helperText: "",
    disabled: false,
    
}

export default TextBox;
